import styled from "styled-components";

export const Container = styled.div`
    display: flex;

    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 40px;
    padding: 175px 0px
`;

export const LoadingImage = styled.img`

    width: 96px;
    height: 96px;


    animation: spin 1s linear infinite;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
        }

    `;